var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('columns',[_c('column',{staticClass:"is-12"},[_c('order-view',{attrs:{"order-id":_vm.orderId,"routes":_vm.routes}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }